import React, { Suspense, lazy } from 'react';
import Layout from '../../components/layouts';
import styles from './styles.module.scss';
import {useUserContext} from '../../providers/user-context';
import {Navigate} from 'react-router-dom';
import {APP_PATHS} from '../../constants';
import SectionLoader from '../../components/section-loader';
import { useVersion } from 'hooks/useVersion';

// Import critical section and data
import WelcomeSection from './welcome-section';
import homeDate from './home-data.json';

// Lazy load non-critical sections with simulated delay
const TestimonialsSection = lazy(() => import('./testimonials-section'));
const HowItWorksSection = lazy(() => (import('./how-it-works')));
const KPIsSection = lazy(() => (import('./kpi-section')));
const CashoutViaSection = lazy(() => 
  (import('./cashout-via-section')).then(module => ({ 
    default: module.CashoutViaSection 
  }))
);
const FAQAccordion = lazy(() => (import('./faq-section')));

const HomePage: React.FC = () => {
  const {user} = useUserContext();
  const version = useVersion();

  // If user is logged in, redirect to offers page
  if (user) {
    return <Navigate to={APP_PATHS.OFFERS} replace={true} />;
  }

  // If version is not set show null to avoid rendering the page and flickering
  if (version === null) {
    return null;
  } 

  return (
    <Layout>
      <div className={styles.section}>
        <WelcomeSection gameCards={homeDate.gameCards} version={version}/>
        <Suspense fallback={<SectionLoader />}>
          <TestimonialsSection testimonialsData={homeDate.testimonialsData} />
          <KPIsSection kpisData={homeDate.kpisData}/>
          <HowItWorksSection howItWorksStep={homeDate.hiwData} />
          <CashoutViaSection />
          <FAQAccordion faqItem={homeDate.faqData} />
        </Suspense>
      </div>
    </Layout>
  );
};

export default HomePage;
